import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onBeforeMount, reactive, ref } from "vue";
import PostList from "@/components/PostList.vue";
import ListPagination from "@/components/ListPagination.vue";
import { postsSearchPage } from "@/services/portalService";
import { useRoute } from "vue-router";
import { PostItem } from "@/models/Post";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchView',
  setup(__props) {

const route = useRoute();

const list = ref<PostItem[]>([]);

const pagination = reactive({
  currentPage: 1,
  hasNextPage: false,
  hasPreviousPage: false,
  pageSize: 30,
  totalCount: 0,
  totalPages: 0,
});

const changePage = async (value: number) => {
  pagination.currentPage = value;
  await fetchPosts();
};

const fetchPosts = async () => {
  const posts = await postsSearchPage(
    route.params.search.toString(),
    pagination.currentPage
  );
  list.value = posts.items;
  pagination.currentPage = posts.currentPage;
  pagination.hasNextPage = posts.hasNextPage;
  pagination.hasPreviousPage = posts.hasPreviousPage;
  pagination.pageSize = posts.pageSize;
  pagination.totalCount = posts.totalCount;
  pagination.totalPages = posts.totalPages;
};

onBeforeMount(async () => {
  fetchPosts();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t("search-page.title")), 1),
    _createVNode(PostList, { posts: list.value }, null, 8, ["posts"]),
    _createVNode(ListPagination, {
      currentPage: pagination.currentPage,
      hasNext: pagination.hasNextPage,
      hasPrevious: pagination.hasPreviousPage,
      totalPages: pagination.totalPages,
      pageSize: pagination.pageSize,
      totalItems: pagination.totalCount,
      onChangePage: changePage
    }, null, 8, ["currentPage", "hasNext", "hasPrevious", "totalPages", "pageSize", "totalItems"])
  ]))
}
}

})